import { createRouter, createWebHistory } from 'vue-router';
import LoginView from './views/LoginView.vue';
import MenuView from './views/MenuView.vue';
import UploadView from './views/UploadView.vue';
import DockerManageView from './views/DockerManageView.vue';
import UserUpdateView from './views/UserUpdateView.vue';
import UserManageView from './views/UserManageView.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: LoginView },
  { path: '/menu', component: MenuView, meta: { requiresAuth: true } },
  { path: '/upload', component: UploadView, meta: { requiresAuth: true } },
  {
    path: '/manage',
    component: DockerManageView,
    meta: { requiresAuth: true },
  },
  { path: '/users', component: UserManageView, meta: { requiresAuth: true } },
  { path: '/update', component: UserUpdateView },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// ナビゲーションガード：requiresAuth ルートはセッションチェック
router.beforeEach(async (to, _from, next) => {
  if (!to.meta.requiresAuth) return next();
  try {
    const { default: api } = await import('./api.js');
    await api.get('/api/admin/me');
    next();
  } catch {
    next('/login');
  }
});

export default router;
